import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { createMuiTheme, withStyles, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import Icon from '@mdi/react';
import { mdiLoading } from '@mdi/js';

import wpStyles from '../../wordpressStyles';

const CustomButton = withStyles(theme => ({
    root: {
        boxShadow: 'none',
        color: '#ffffff',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 100%), '+wpStyles.color1+';',
        borderRadius: '9999px',
        borderColor: '#ffffff',
        textTransform: 'none',
        padding: '0.7em 2.5em',
        fontSize: '15px',
        height: '50px',
        '&:hover': {
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%), '+wpStyles.color1+';'
        }
    }
}))(Button);

const CustomButtonToggled = withStyles(theme => ({
    root: {
        boxShadow: 'none',
        color: wpStyles.color1,
        background: '#ffffff',
        borderColor: wpStyles.color1,
        borderRadius: '9999px',
        textTransform: 'none',
        padding: '0.7em 2.5em',
        fontSize: '15px',
        '&:hover': {
            backgroundColor: '#dddddd'
        }
    }
}))(Button);

class CTAButton extends React.Component {
    render() {
        if (this.props.busy) return <Icon path={mdiLoading} size={1} className="inline" spin />;
        else if (this.props.toggled) {
            return (
                <CustomButtonToggled
                    variant="outlined"
                    onClick={() => this.props.onButtonClick()}
                    disabled={this.props.disabled}
                >
                    {this.props.text}
                </CustomButtonToggled>
            );
        } else {
            return (
                <CustomButton
                    variant="outlined"
                    onClick={() => this.props.onButtonClick()}
                    disabled={this.props.disabled}
                >
                    {this.props.text}
                </CustomButton>
            );
        }
    }
}

CTAButton.defaultProps = {
    url: 'javascript:void(0)',
    text: 'button',
    busy: false,
    disabled: false,
    toggled: false,
    onButtonClick: () => {}
};

export default CTAButton;
